import { Alert, Button } from "@mui/material";
import useWithUrlTenant from "src/hooks/useTenant";

export default function PackVersionReminder({ sx }) {
  const withTenant = useWithUrlTenant();

  const handleOpenAppSettings = () => {
    window.open(
      withTenant(`/dashboard/app-settings`),
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <Alert
      severity="info"
      sx={sx}
      action={
        <Button color="inherit" size="small" onClick={handleOpenAppSettings}>
          Open App Settings
        </Button>
      }
    >
      If you update pack assets, please also update the pack version in App
      Settings.
    </Alert>
  );
}
